<template>
    <div class="box">
        <Header></Header>

        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;margin-bottom:10px;">企业理念</p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">企业精神：</span><span style="color:#5B5B5B;width:75%;">永不放弃、永不止步。</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">廉洁理念：</span><span style="color:#5B5B5B;width:75%;">清白为企，慎权守法。</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">人才理念：</span><span style="color:#5B5B5B;width:75%;">以人为本，唯才是用。</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">企业愿景：</span><span style="color:#5B5B5B;width:75%;">成为中国煤炭运销行业的领跑者。</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:25%;color:#141414;font-weight: bold;">企业使命：</span><span style="color:#5B5B5B;width:75%;">发展企业、贡献国家、服务社会、造福员工。</span></p>
                
                <!-- border-bottom:1px solid #E7E7E7;padding-bottom:20px;
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Enterprise Spirit：</span><span style="color:#5B5B5B;width:56%;">Never give up, Never stop.</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Honest Notion：</span><span style="color:#5B5B5B;width:56%;">Honest and Clean , Prudent and Law-abiding.</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Talent Philosophy：</span><span style="color:#5B5B5B;width:56%;">People-oriented, Talent-orien ted.</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Enterprise Vision：</span><span style="color:#5B5B5B;width:56%;">To become the industry leader in China's coal transportation.</span></p>
                <p style="font-size: 15px;color:#909090;padding-top: 15px;display: flex;"><span style="width:44%;color:#141414;font-weight: bold;">Corporate mission：</span><span style="color:#5B5B5B;width:56%;">To develop enterprises. Cont ribute to the country. Serve the community. The benefit of staff.</span></p> -->
            </div>

            <Footer></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'enterpriseConcept',
	components: {
		Header,
        Footer
	},
	data () {
		return {
            banner: {}
		}
	},

	mounted() {
        this.getData();
	},

	methods: {
        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 11
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/companyProfile/enterpriseConcept.vue